import { branchesService } from "@/apis/services"
import { IBranch, IPaginationMeta, IPaginationParamV2 } from "@/types"
import { create } from "zustand"
import { devtools } from "zustand/middleware"

interface IBranchState {
  branches: IBranch[]
  currentBranch: IBranch | null
  meta?: IPaginationMeta
  isLoading: boolean
  error: string | null
  fetchBranches: (params: IPaginationParamV2) => Promise<void>
}

const initialState = {
  branches: [],
  currentBranch: null,
  meta: undefined,
  isLoading: false,
  error: null,
}

export const useBranchesStore = create<IBranchState>()(
  devtools(set => ({
    ...initialState,

    fetchBranches: async (params: IPaginationParamV2) => {
      set({ isLoading: true, error: null })
      try {
        const response = await branchesService.getBranches(params)
        set({ branches: response.data.items, meta: response.data.meta })
      } catch (error) {
        const errorMessage: string = error instanceof Error ? error.message : "An unknown error occurred"
        set({ error: errorMessage })
        throw error
      } finally {
        set({ isLoading: false })
      }
    },
  }))
)
